import React from 'react';
import errorImg from '../images/errorimg.jpg';

const Error = () => {
    return (
        <>
        <div className="error" style={{
            background:`url(${errorImg})`,
            backgroundPosition:'center',
            backgroundRepeat:'no-repeat',
            backgroundSize:'cover',
            opacity:'0.3',
            width:'60%',
            minHeight:'100vh',
            margin:'0px auto',
            padding:'40px',
            textAlign:'center'
        }}></div>
        <div style={{
            textAlign:'center',
            position:'absolute',
            top:'200px',
            left:'28%'
        }}>
            <h1 style={{fontSize:'3rem'}}>OOPS!!!!</h1>
            <h2 style={{fontSize:'2.5rem'}}>404 - Page Not Found</h2>
            <p style={{fontSize:'2rem'}}>“Sorry, we can’t find the page you were looking for.”</p>
        </div>
        </>
    )
}

export default Error;
